import { defineComponent as _defineComponent } from 'vue'
import { useBasicStore } from '@/stores/basic';
import { computed, nextTick, ref } from 'vue';
import { storeToRefs } from 'pinia';
import RoomInvite from '../RoomInvite/index.vue';
import RoomMore from '../RoomMore/index.vue';
import ManageMember from '../ManageMember/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const basicStore = useBasicStore();
const { isModelOpen, modelTName } = storeToRefs(basicStore);
const isRouterAlive = ref(true);

const title = computed((): string | undefined => {
  if (modelTName.value === 'invite') {
    return '邀请成员';
  }
  if (modelTName.value === 'more') {
    return '联系我们';
  }
  if (modelTName.value === 'manage-member') {
    return '成员管理';
  }
  return '';
});

function handleClose(done: any) {
  basicStore.setModelOpenStatus(false);
  basicStore.setModelTName('');
  done();
}

return { __sfc: true,basicStore, isModelOpen, modelTName, isRouterAlive, title, handleClose, RoomInvite, RoomMore, ManageMember }
}

})